import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../lib/api.js';
import { useAuth } from '../lib/auth.jsx';

export default function ChangePassword() {
  const { user, markPasswordChanged } = useAuth();
  const nav = useNavigate();
  const forced = !!user?.must_change_password;
  const [currentPw, setCurrentPw] = useState('');
  const [newPw, setNewPw] = useState('');
  const [confirm, setConfirm] = useState('');
  const [err, setErr] = useState(null);
  const [busy, setBusy] = useState(false);

  async function submit(e) {
    e.preventDefault();
    setErr(null);
    if (newPw.length < 8) return setErr('New password must be at least 8 characters');
    if (newPw !== confirm) return setErr('New password confirmation does not match');
    setBusy(true);
    try {
      await api.changePassword({ current_password: currentPw, new_password: newPw });
      markPasswordChanged();
      nav('/', { replace: true });
    } catch (e) {
      setErr(e.body?.message || e.message || 'failed');
    } finally { setBusy(false); }
  }

  return (
    <div className="min-h-screen flex items-center justify-center p-4 bg-slate-50">
      <form onSubmit={submit} className="card w-full max-w-sm p-6 space-y-4 bg-white rounded-lg shadow">
        <div>
          <h1 className="text-xl font-bold" style={{ color: 'var(--brand-primary)' }}>
            {forced ? 'Set your password' : 'Change password'}
          </h1>
          <p className="text-sm text-slate-500">
            {forced
              ? 'Your administrator gave you a temporary password. Choose a new one to continue.'
              : 'Update the password on your account.'}
          </p>
        </div>
        {!forced && (
          <div>
            <label className="block text-xs font-medium text-slate-700 mb-1">Current password</label>
            <input className="input" type="password" value={currentPw}
                   onChange={e => setCurrentPw(e.target.value)} required />
          </div>
        )}
        <div>
          <label className="block text-xs font-medium text-slate-700 mb-1">New password</label>
          <input className="input" type="password" value={newPw}
                 onChange={e => setNewPw(e.target.value)} minLength={8} required />
          <div className="text-xs text-slate-500 mt-1">Minimum 8 characters.</div>
        </div>
        <div>
          <label className="block text-xs font-medium text-slate-700 mb-1">Confirm new password</label>
          <input className="input" type="password" value={confirm}
                 onChange={e => setConfirm(e.target.value)} required />
        </div>
        {err && <div className="text-sm text-red-600">{err}</div>}
        <button className="btn-primary w-full" disabled={busy}>
          {busy ? 'Saving…' : 'Save password'}
        </button>
      </form>
    </div>
  );
}
